import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { PropertyService } from '../shared/property.service';
import { EventService } from '../shared/event.service';
import { Viewing } from './viewing';
import { PortalLeadsData } from './portalLeadsData';
import { ViewingUpdate } from './viewing-update';
import { DataService } from '../shared/data.service';
import { NgForm } from '@angular/forms/src/forms';
import { DatePipe } from '@angular/common';
import * as Moment from 'moment/moment';


@Component({
  selector: 'sold-viewingform',
  templateUrl: './viewingform.component.html',
  styleUrls: [
    './viewingForm.component.scss'
  ],
  providers: [DatePipe]
})
export class ViewingformComponent implements OnInit {

  @Output() openNav = new EventEmitter();

    addresses: any[];
    errorMessage: any;
    recordID: number;
    showForm1: boolean;
    showFormConf: boolean;
    minDate: any;
    confTitle: any;
    confText: any;

    gdpiAgree: boolean;

    constructor(
      public _propertyService: PropertyService,
      private _eventService: EventService,
      private _dataService: DataService,
      public _datepipe: DatePipe
    ) {
      this.showForm1 = true;
      this.minDate = this._datepipe.transform(new Date(), 'yyyy-MM-dd');
      this.confTitle = 'Find a date that works for you';
      this.confText = "We\'ll call to confirm your appointment";
      this.gdpiAgree = false;
    }

    nowDateDt = new Date();

    

    nowDate = this.nowDateDt.getFullYear().toString() + "-" + (this.nowDateDt.getMonth() + 1 ).toString() + "-" + this.nowDateDt.getDate().toString() + " " + this.nowDateDt.getHours().toString() + ":" + this.nowDateDt.getMinutes().toString() + ":" + this.nowDateDt.getSeconds().toString() + "." + this.nowDateDt.getMilliseconds().toString();

    model = new Viewing(this._propertyService.brand, '', this._propertyService.address, '', '', '', '', '', false, '', '', '', 'noreply@haybrook.com', this._propertyService.OfficeID);
    updateModel = new ViewingUpdate(0, '', '');
    portalLead = new PortalLeadsData(this.nowDate, this.nowDate,'N', "Flink", this.nowDate, 0, false);

    onSubmit(form: NgForm) {

      if (form.invalid) {
          return;
      } else {
        if(!this.gdpiAgree) {
          return;
        }


        if (this.model.Email == null) {
          this.model.Email= '-';
        }

        this.model.PropertyReference = this._propertyService.propRef;
        //this.model.referrer = this._propertyService.referrer;

        this.displayUpdateForm();

          // this._dataService.processValuation(this.model)
          //   .subscribe(
          //     data => (this.formSubmitCheck(data), this.recordID = JSON.parse(data).Data.result, this.displayUpdateForm()),
          //     err =>  this.formSubmitCheck(err),
          //   );
      }
    }

    onSubmit2(form: NgForm) {

      if (form.invalid) {
        return;
      } else {
        //this.updateModel.id = this.recordID;

        if (this.model.FirstName.includes(" ")) {
          var fullName = this.model.FirstName.split(" ");
          this.model.FirstName = fullName[0];
          this.model.LastName  = fullName[1];
        }

        this.model.ViewingDate = Moment(this.updateModel.preferredDate).format('Do MMM YYYY');
        this.model.ViewingTime = this.updateModel.preferredTime;
        this.model.BranchEmail = this._propertyService.OfficeEmail;

        this._dataService.getOfficeCode(this.model.OfficeId)
        .subscribe(data => (
          this.portalLead.PortalBranchId = data,
          this.portalLead.EnquiryId = 0,
          this.portalLead.CustPropertyToSell = false,
          this.portalLead.CustArrangeValuation = false,
          this.portalLead.CustArrangeViewing = false,
          this.portalLead.CustHelpWithMortgage = false,
          this.portalLead.CustSendPropDetails = false,
          this.portalLead.BranchRef = this.model.OfficeId,
          this.portalLead.CustArrangeViewing = true,
          this.portalLead.CustEmail = this.model.Email,
          this.portalLead.ToEmail = this.model.BranchEmail,
          this.portalLead.CustTitle = "-",
          this.portalLead.CustFirstname = this.model.FirstName,
          this.portalLead.CustSurname = this.model.LastName,
          this.portalLead.CustDayPhone = this.model.PhoneNumber,
          this.portalLead.CustPropertyToSell = false,
          this.portalLead.PropReference = this.model.PropertyReference,
          this.portalLead.Notes = "Would like to view the selected house at the following date and time: " + this.model.ViewingDate + " at " + this.model.ViewingTime,
          this._dataService.processViewing(this.portalLead)
            .subscribe(
              data => console.log('data: ', data),
              err =>  this.formSubmitCheck(err),
          )
        ),
          err =>  this.formSubmitCheck(err),
        );

        this.confTitle = 'Your viewing request has been sent to our team';
        this.confText = 'Our branch will call shortly to arrange your viewing';
        this.showFormConf = true;
      }
    }

    formSubmitCheck(returnData: string) {
      if (returnData.indexOf('Phone Invalid') >= 0) {
        document.getElementById('phone').classList.remove('ng-valid');
        document.getElementById('phone').classList.add('formInvalid');
      }
    }

    formSubmit2Check(returnData: string) {}

    displayUpdateForm() {
      this.showForm1 = false;
      this.showFormConf = false;
    }

    closeSidenav() {
      this.confTitle = 'Thanks, we\'ll be in touch';
      this.confText = 'Would you like to be contacted at a particular time?';
      this.showForm1 = true;
      this.showFormConf = false;
      this._eventService.eventFromSender();
    }

    ngOnInit() {
    }
}




// WEBPACK FOOTER //
// D:/FLINK/FlinkViewingPageDec2020/NewLandingPage/src/app/viewingForm/viewingForm.component.ts